import { DTO } from '@/type-utils';
import { AddressModel } from '../../Address';
import Model from '../../Model';
import type IOrderPhysicalShippingInfo from './IOrderPhysicalShippingInfo';

/**
 * Represents the shipping information for a physical (tangible) order.
 */
export default class OrderPhysicalShippingInfoModel
  extends Model<DTO<IOrderPhysicalShippingInfo>>
  implements IOrderPhysicalShippingInfo
{
  /** @inheritdoc */
  public readonly email: string;
  /** @inheritdoc */
  public readonly phoneNumber: string;
  /** @inheritdoc */
  public readonly shippingMethod: string;
  /** @inheritdoc */
  public readonly address: AddressModel;
  /** @inheritdoc */
  public readonly shouldSaveAddress: boolean;

  /**
   * Creates a new order physical shipping info model.
   * @param data - The data for the model.
   */
  public constructor(
    data: DTO<IOrderPhysicalShippingInfo> | IOrderPhysicalShippingInfo
  ) {
    super(data);

    this.email = data.email;
    this.phoneNumber = data.phoneNumber;
    this.shippingMethod = data.shippingMethod;
    this.address = AddressModel.from(data.address);
    this.shouldSaveAddress = data.shouldSaveAddress ?? false;
  }

  /** @inheritdoc */
  public override toDTO(): DTO<IOrderPhysicalShippingInfo> {
    const dto: DTO<IOrderPhysicalShippingInfo> = {
      email: this.email,
      phoneNumber: this.phoneNumber,
      shippingMethod: this.shippingMethod,
      address: this.address.toDTO(),
      shouldSaveAddress: this.shouldSaveAddress
    };

    return dto;
  }
}
